<template>
    <div class="matrix-filter admin">
        <div class="filter-sort">
            <span>{{ __('Sort by') }}:</span>

            <form action="#">
                <button type="button" :class="{ active: sort === 'newest' }" @click="sort = 'newest'">
                    <span>{{ __('From the latest') }}</span>
                </button>
                <button type="button" :class="{ active: sort === 'oldest' }" @click="sort = 'oldest'">
                    <span>{{ __('From the oldest') }}</span>
                </button>
                <button type="button" :class="{ active: sort === 'vacation' }" @click="sort = 'vacation'">
                    <span>{{ __('Holiday') }}</span>
                </button>
                <button type="button" :class="{ active: sort === 'substitute' }" @click="sort = 'substitute'">
                    <span>{{ __('Substitute') }}</span>
                </button>
            </form>
        </div>

        <div class="filter-search">
            <form action="" autocomplete="off">
                <button type="submit">
                    <svg-icon icon="search-icon-app" />
                </button>

                <button v-if="search" class="filter-remove" type="button" @click.prevent="search = ''">
                    <span class="material-icons-round">close</span>
                </button>

                <input v-model="search" name="search" type="text" :placeholder="__('Find a dietitian')" />
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                sort: 'newest',
                search: ''
            }
        },
        watch: {
            sort() {
                this.$emit('sort', this.sort)
            },
            search() {
                this.$emit('search', this.search)
            }
        }
    }
</script>
